import { Component, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GradesService } from '../grades.service';
import { CurriculumMarkTypes } from '../grades.model';

@Component({
    selector: 'app-code-legend',
    templateUrl: './code-legend.component.html',
    styles: []
})
export class CodeLegendComponent implements AfterViewInit {
    curriculumMarkTypes: CurriculumMarkTypes[] = [];
    ColumnsToDisplay = ['Mark', 'Description'];
    courseId: number;

    constructor(
        private gradesService: GradesService,
        private dialogRef: MatDialogRef<CodeLegendComponent>
    ) { }

    ngAfterViewInit() {
        this.getCurriculumMarkTypes();
    }

    getCurriculumMarkTypes() {
        this.gradesService.getCurriculumMarkTypesReadForSubject(0).subscribe(data => {
            this.curriculumMarkTypes = data.filter(function (ele) { return !ele.InActive; });
        });
    }

    closeClick() {
        this.dialogRef.close('Close was clicked.');
    }
}
